import { ReactNode } from 'react';
import { Badge, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '../hooks/useTheme';

interface DeleteSlotBadgeProps {
    children: ReactNode;
    onCloseClick: (e: React.MouseEvent) => void;
    customSx?: object;
}

const DeleteSlotBadge = ({ children, onCloseClick, customSx }: DeleteSlotBadgeProps) => {
    const theme = useTheme();

    return (
        <Badge
            overlap="rectangular"
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{ ...customSx }}
            badgeContent={
                <Box
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        borderRadius: '50%',
                        marginTop: '2em',
                        width: 18,
                        height: 18,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0 0 4px rgba(0,0,0,0.3)'
                    }}
                    onClick={onCloseClick}
                >
                    <CloseIcon
                        sx={{
                            fontSize: '1rem',
                            color: theme.palette.error.main
                        }}
                    />
                </Box>
            }
        >
            {children}
        </Badge>
    );
};

export default DeleteSlotBadge;
